import React, { useEffect, useRef } from 'react'
import styles from './ModalCard.module.scss'
import Button from '../../molecules/Button/Button';
import { JWayIcon } from '../../../assets/JWayIcons';

// L'app est embarquée dans une iframe redimensionnée à la hauteur totale de son
// contenu (compta-app utils/IFrame.js) : le viewport CSS de l'iframe couvre tout
// le document, un centrage écran en CSS pur est donc impossible et le scroll est
// géré par la page parente (cross-origin). scrollIntoView traverse les iframes et
// fait défiler le parent pour amener la modale au centre de la zone visible.
function useScrollModalIntoView() {
  const cardRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    cardRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  }, [])
  return cardRef
}

export interface ModalProps {
    title?: string;
    description?:    string;
    onClose?: () => void;
    handleValidate?: () => void;
    labelValidate?: string;
    withCancelBtn?: boolean;
    children?: React.ReactNode;
    style?: React.CSSProperties;

}

export interface ModalCardProps {
  title: string;
  description?:    string;
  onClose: () => void;
  handleValidate?: () => void;
  labelValidate?: string;
  withCancelBtn?: boolean;



}
export default function ModalCard({title, description, onClose, labelValidate="OK", withCancelBtn, handleValidate}: ModalCardProps) {
  const cardRef = useScrollModalIntoView()
  return (
    <div className={styles['background']}>
      <div className={styles['modal-card']} ref={cardRef}>
        <div className={styles['modal-card__header']}>
          <h2 className={styles['modal-card__title']}>{title}</h2>
        </div>
        <div className={styles['modal-card__content']}>
          <p>{description}</p>
        </div>
        <div className={styles['modal-card__footer']}>
            {withCancelBtn &&  <div className={styles['btn']}><Button label="Annuler" onClick={() => {onClose()}} style="gray" /></div>} {/*eslint-disable-line*/}
          
            <div className={styles['btn']}><Button label={labelValidate} onClick={() => { if(handleValidate){ handleValidate() }else{onClose()}}}/></div>

        </div>
      </div>
    </div>
  )
}

export function Modal({title, description, onClose, labelValidate="OK", withCancelBtn, handleValidate, children, style

}: ModalProps) {
  const cardRef = useScrollModalIntoView()
  return (
    <div className={styles['background']}>
      <div className={styles['modal-card']} style={style} ref={cardRef}>
      <div className={styles['modal-card__header']}>
        <button className={[styles['header__btn-close'], styles['btn-close']].join(' ')} onClick={onClose}>
          <JWayIcon type='cross' size={20}/>
        </button>

      </div>
        <div className={styles['modal-card__content']}>
         {children}
        </div>

      </div>
    </div>
  )
}

